import { render, staticRenderFns } from "./search.vue?vue&type=template&id=64748429"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"
import style0 from "./search.vue?vue&type=style&index=0&id=64748429&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/app/components/img.vue').default,ProductPrices: require('/app/components/product/prices.vue').default,Empty: require('/app/components/empty.vue').default})
